import * as React from "react"
export const PercentIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g clipPath='url(#clip0_137_2178)'>
      <path
        d='M8.6856 7.76515C9.4571 6.92834 9.88218 5.80587 9.88218 4.60418C9.88218 2.31618 8.24793 0 5.12388 0C3.67001 0 2.44349 0.499364 1.57675 1.44408C0.808991 2.28101 0.386285 3.40323 0.386285 4.60418C0.386285 6.89242 2.01361 9.20848 5.12388 9.20848C6.58317 9.20854 7.81505 8.70955 8.6856 7.76515ZM5.12388 2.14079C6.8356 2.14079 7.61515 3.41858 7.61515 4.6058C7.61515 5.25162 7.39784 5.84947 7.00289 6.28901C6.56228 6.77996 5.92195 7.03956 5.15163 7.03956C3.39663 7.03956 2.59712 5.76189 2.59712 4.5748C2.59712 3.36344 3.37854 2.14079 5.12388 2.14079Z'
        fill='currentColor'
      />
      <path
        d='M16.4853 1.77568C16.2022 1.7808 15.8156 1.95732 15.6263 2.16783L1.57247 17.7932C1.38317 18.0038 1.51727 18.2991 1.80038 18.2991H3.63978C3.9229 18.2991 4.30905 18.1265 4.49805 17.9156L18.465 2.29345C18.6539 2.08244 18.6413 1.73913 18.1735 1.73926L16.4853 1.77568Z'
        fill='currentColor'
      />
      <path
        d='M14.9512 10.9668C13.5254 10.9668 12.3222 11.4569 11.4718 12.3836C10.7187 13.2043 10.3038 14.3054 10.3038 15.4835C10.3038 17.728 11.9002 20.0001 14.9513 20.0001C16.3832 20.0001 17.5913 19.5105 18.4455 18.5842C19.2024 17.7632 19.6192 16.6621 19.6192 15.4835C19.6191 13.2391 18.0158 10.9668 14.9512 10.9668ZM14.9788 17.9275C13.2713 17.9275 12.4933 16.6452 12.4933 15.4545C12.4933 14.806 12.7105 14.2059 13.1051 13.7646C13.5451 13.2723 14.1834 13.012 14.9513 13.012C16.6589 13.012 17.4365 14.294 17.4365 15.4852C17.4365 16.1335 17.2193 16.7338 16.8249 17.175C16.3849 17.6672 15.7465 17.9275 14.9788 17.9275Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_137_2178'>
        <rect width={20} height={20} fill='white' />
      </clipPath>
    </defs>
  </svg>
)
